import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		content: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(3),
		},
		stepHeading: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2),
		},
		counter: {
			fontSize: 16,
			lineHeight: "24px",
			color: theme.palette.custom.textSecondary,
		},
		// Figma's export renders the Web/Body1 step heading semibold (VPLAT 20, OSEO 4).
		stepTitle: {
			fontSize: 18,
			fontWeight: 600,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
	} satisfies Record<string, CSSObject>);
};
